// Generated model display config
// This file is auto-generated - do not edit manually

export const modelDisplayConfig = {
  Action: { label: "RFLPAction", labelPlural: "RFLPActions" },
  ActionDefinition: { label: "Action Definition", labelPlural: "Action Definitions" },
  ActionInputParameter: { label: "RFLPActionInputParameter", labelPlural: "RFLPActionInputParameters" },
  ActionOutputParameter: { label: "RFLPActionOutputParameter", labelPlural: "RFLPActionOutputParameters" },
  ActionParameter: { label: "RFLPActionParameter", labelPlural: "RFLPActionParameters" },
  ActionRoot: { label: "Action Root", labelPlural: "Action Roots" },
  ActionUsage: { label: "Action Usage", labelPlural: "Action Usages" },
  ActionValidationTask: { label: "Action Validation Task", labelPlural: "Action Validation Tasks" },
  AnalysisRecord: { label: "RFLPAnalysisRecord", labelPlural: "RFLPAnalysisRecords" },
  Answer: { label: "Answer", labelPlural: "Answers" },
  AttachedRecord: { label: "Attached Record", labelPlural: "Attached Records" },
  Attribute: { label: "RFLPAttribute", labelPlural: "RFLPAttributes" },
  AttributeDefinition: { label: "Attribute Definition", labelPlural: "Attribute Definitions" },
  AttributeExpansionTask: { label: "Attribute Expansion Task", labelPlural: "Attribute Expansion Tasks" },
  AttributeUsage: { label: "Attribute Usage", labelPlural: "Attribute Usages" },
  AttributeValue: { label: "RFLPAttributeValue", labelPlural: "RFLPAttributeValues" },
  CalculationState: { label: "Calculation State", labelPlural: "Calculation States" },
  CatalogNode: { label: "Catalog Node", labelPlural: "Catalog Nodes" },
  ChangeImpact: { label: "RFLPChangeImpact", labelPlural: "RFLPChangeImpacts" },
  ChangeProposal: { label: "RFLPChangeProposal", labelPlural: "RFLPChangeProposals" },
  ChatSkillsTask: { label: "Chat Skills Task", labelPlural: "Chat Skills Tasks" },
  ChatTask: { label: "Chat Task", labelPlural: "Chat Tasks" },
  ComponentExtractionTask: { label: "Component Extraction Task", labelPlural: "Component Extraction Tasks" },
  ComponentMatchTask: { label: "Component Match Task", labelPlural: "Component Match Tasks" },
  Concern: { label: "RFLPConcern", labelPlural: "RFLPConcerns" },
  Connection: { label: "RFLPConnection", labelPlural: "RFLPConnections" },
  Constraint: { label: "RFLPConstraint", labelPlural: "RFLPConstraints" },
  ConstraintDefinition: { label: "Constraint Definition", labelPlural: "Constraint Definitions" },
  ConstraintUsage: { label: "Constraint Usage", labelPlural: "Constraint Usages" },
  ControlFlow: { label: "Control Flow", labelPlural: "Control Flows" },
  ControlPort: { label: "RFLPControlPort", labelPlural: "RFLPControlPorts" },
  DanglingPortResolutionTask: { label: "Dangling Port Resolution Task", labelPlural: "Dangling Port Resolution Tasks" },
  DataFlow: { label: "Data Flow", labelPlural: "Data Flows" },
  DatabaseReference: { label: "Database Reference", labelPlural: "Database References" },
  DeduplicationTask: { label: "Deduplication Task", labelPlural: "Deduplication Tasks" },
  DerivedExpression: { label: "RFLPDerivedExpression", labelPlural: "RFLPDerivedExpressions" },
  DerivedValue: { label: "RFLPDerivedValue", labelPlural: "RFLPDerivedValues" },
  DiscreteAttribute: { label: "RFLPDiscreteAttribute", labelPlural: "RFLPDiscreteAttributes" },
  EntityExtractionTask: { label: "Entity Extraction Task", labelPlural: "Entity Extraction Tasks" },
  EntityMatchTask: { label: "Entity Match Task", labelPlural: "Entity Match Tasks" },
  Expression: { label: "Expression", labelPlural: "Expressions" },
  ExtractionSummaryTask: { label: "Extraction Summary Task", labelPlural: "Extraction Summary Tasks" },
  FluidFlow: { label: "Fluid Flow", labelPlural: "Fluid Flows" },
  FunctionMatchTask: { label: "Function Match Task", labelPlural: "Function Match Tasks" },
  FunctionalBlockExtractionTask: { label: "Functional Block Extraction Task", labelPlural: "Functional Block Extraction Tasks" },
  FunctionalBreakdownTask: { label: "Functional Breakdown Task", labelPlural: "Functional Breakdown Tasks" },
  FunctionalModule: { label: "Functional Module", labelPlural: "Functional Modules" },
  FunctionalSubsystem: { label: "Functional Subsystem", labelPlural: "Functional Subsystems" },
  GlossaryTerm: { label: "RFLPGlossaryTerm", labelPlural: "RFLPGlossaryTerms" },
  Group: { label: "Group", labelPlural: "Groups" },
  Industry: { label: "Industry", labelPlural: "Industrys" },
  InquiriesSummaryTask: { label: "Inquiries Summary Task", labelPlural: "Inquiries Summary Tasks" },
  InquirySolvingTask: { label: "Inquiry Solving Task", labelPlural: "Inquiry Solving Tasks" },
  InterfaceDefinition: { label: "Interface Definition", labelPlural: "Interface Definitions" },
  InterfaceExpansionTask: { label: "Interface Expansion Task", labelPlural: "Interface Expansion Tasks" },
  InterfacePort: { label: "RFLPInterfacePort", labelPlural: "RFLPInterfacePorts" },
  IntrinsicExpansionTask: { label: "Intrinsic Expansion Task", labelPlural: "Intrinsic Expansion Tasks" },
  Invite: { label: "Invite", labelPlural: "Invites" },
  IslandPin: { label: "Island Pin", labelPlural: "Island Pins" },
  IslandRoot: { label: "Island Root", labelPlural: "Island Roots" },
  Item: { label: "RFLPItem", labelPlural: "RFLPItems" },
  ItemDefinition: { label: "Item Definition", labelPlural: "Item Definitions" },
  ItemFlow: { label: "RFLPItemFlow", labelPlural: "RFLPItemFlows" },
  ItemUsage: { label: "Item Usage", labelPlural: "Item Usages" },
  LLMTask: { label: "LLM Task", labelPlural: "LLM Tasks" },
  LogicalPart: { label: "RFLPLogicalPart", labelPlural: "RFLPLogicalParts" },
  MBSE_Action: { label: "MBSE Action", labelPlural: "MBSE Actions" },
  MBSE_Attribute: { label: "MBSE Attribute", labelPlural: "MBSE Attributes" },
  MBSE_Package: { label: "MBSE Package", labelPlural: "MBSE Packages" },
  MBSE_Part: { label: "MBSE Part", labelPlural: "MBSE Parts" },
  MBSE_Port: { label: "MBSE Port", labelPlural: "MBSE Ports" },
  MBSE_Requirement: { label: "MBSE Requirement", labelPlural: "MBSE Requirements" },
  MainPortExtractionTask: { label: "Main Port Extraction Task", labelPlural: "Main Port Extraction Tasks" },
  Material: { label: "Material", labelPlural: "Materials" },
  MaterialExtractionTask: { label: "Material Extraction Task", labelPlural: "Material Extraction Tasks" },
  ModelRequest: { label: "Model Request", labelPlural: "Model Requests" },
  ModelResponse: { label: "Model Response", labelPlural: "Model Responses" },
  ModularBreakdownTask: { label: "Modular Breakdown Task", labelPlural: "Modular Breakdown Tasks" },
  ModularRequirementAnalysisTask: { label: "Modular Requirement Analysis Task", labelPlural: "Modular Requirement Analysis Tasks" },
  NeoNode: { label: "Neo Node", labelPlural: "Neo Nodes" },
  NodeAPI: { label: "Node API", labelPlural: "Node APIs" },
  NodeMergeTask: { label: "Node Merge Task", labelPlural: "Node Merge Tasks" },
  NumericAttribute: { label: "RFLPNumericAttribute", labelPlural: "RFLPNumericAttributes" },
  Organisation: { label: "Organisation", labelPlural: "Organisations" },
  PDMAction: { label: "Action", labelPlural: "Actions" },
  PDMItemFlow: { label: "PDM Item Flow", labelPlural: "PDM Item Flows" },
  PDMPart: { label: "Part", labelPlural: "Parts" },
  PDMPort: { label: "PDM Port", labelPlural: "PDM Ports" },
  PDMProduct: { label: "Product", labelPlural: "Products" },
  PDMRequirement: { label: "Requirement", labelPlural: "Requirements" },
  PDMSupplyChainCriteria: { label: "Supply Chain Criteria", labelPlural: "Supply Chain Criteria" },
  Part: { label: "RFLPPart", labelPlural: "RFLPParts" },
  PartAllocationTask: { label: "Part Allocation Task", labelPlural: "Part Allocation Tasks" },
  PartBreakdownTask: { label: "Part Breakdown Task", labelPlural: "Part Breakdown Tasks" },
  PartDefinition: { label: "Part Definition", labelPlural: "Part Definitions" },
  PartPerformsTask: { label: "Part Performs Task", labelPlural: "Part Performs Tasks" },
  PartUsage: { label: "Part Usage", labelPlural: "Part Usages" },
  PhysicalPart: { label: "RFLPPhysicalPart", labelPlural: "RFLPPhysicalParts" },
  PhysicsPort: { label: "RFLPPhysicsPort", labelPlural: "RFLPPhysicsPorts" },
  Port: { label: "RFLPPort", labelPlural: "RFLPPorts" },
  PortConnectionTask: { label: "Port Connection Task", labelPlural: "Port Connection Tasks" },
  PortDefinition: { label: "Port Definition", labelPlural: "Port Definitions" },
  PortExpansionTask: { label: "Port Expansion Task", labelPlural: "Port Expansion Tasks" },
  PortUsage: { label: "Port Usage", labelPlural: "Port Usages" },
  PowerFlow: { label: "Power Flow", labelPlural: "Power Flows" },
  PrivateNode: { label: "Private Node", labelPlural: "Private Nodes" },
  ProductExtractionTask: { label: "Product Extraction Task", labelPlural: "Product Extraction Tasks" },
  ProductMatchTask: { label: "Product Match Task", labelPlural: "Product Match Tasks" },
  ProductQueryExtractionTask: { label: "Product Query Extraction Task", labelPlural: "Product Query Extraction Tasks" },
  ProductRequirementsAnalysisTask: { label: "Product Requirements Analysis Task", labelPlural: "Product Requirements Analysis Tasks" },
  ProductSupplyChainAnalysisTask: { label: "Product Supply Chain Analysis Task", labelPlural: "Product Supply Chain Analysis Tasks" },
  Project: { label: "RFLPProject", labelPlural: "RFLPProjects" },
  ProposalBatch: { label: "RFLPProposalBatch", labelPlural: "RFLPProposalBatchs" },
  Question: { label: "Question", labelPlural: "Questions" },
  Questionnaire: { label: "Questionnaire", labelPlural: "Questionnaires" },
  RFLPElement: { label: "RFLP Element", labelPlural: "RFLP Elements" },
  RFLPTask: { label: "RFLP Task", labelPlural: "RFLP Tasks" },
  Requirement: { label: "RFLPRequirement", labelPlural: "RFLPRequirements" },
  RequirementDefinition: { label: "Requirement Definition", labelPlural: "Requirement Definitions" },
  RequirementExtractionTask: { label: "Requirement Extraction Task", labelPlural: "Requirement Extraction Tasks" },
  RequirementMatchTask: { label: "Requirement Match Task", labelPlural: "Requirement Match Tasks" },
  RequirementSatisfactionTask: { label: "Requirement Satisfaction Task", labelPlural: "Requirement Satisfaction Tasks" },
  RequirementUsage: { label: "Requirement Usage", labelPlural: "Requirement Usages" },
  ResponsePart: { label: "Response Part", labelPlural: "Response Parts" },
  ScopedNode: { label: "Scoped Node", labelPlural: "Scoped Nodes" },
  SecurityScope: { label: "Security Scope", labelPlural: "Security Scopes" },
  SemanticMapSummaryTask: { label: "Semantic Map Summary Task", labelPlural: "Semantic Map Summary Tasks" },
  SimpleFunctionalDependency: { label: "Simple Functional Dependency", labelPlural: "Simple Functional Dependencys" },
  SoftwarePart: { label: "RFLPSoftwarePart", labelPlural: "RFLPSoftwareParts" },
  SourceDocument: { label: "RFLPSourceDocument", labelPlural: "RFLPSourceDocuments" },
  StakeholderNeed: { label: "RFLPStakeholderNeed", labelPlural: "RFLPStakeholderNeeds" },
  Standard: { label: "RFLPStandard", labelPlural: "RFLPStandards" },
  StatementSplitTask: { label: "Statement Split Task", labelPlural: "Statement Split Tasks" },
  StatementsSummaryTask: { label: "Statements Summary Task", labelPlural: "Statements Summary Tasks" },
  Step: { label: "Step", labelPlural: "Steps" },
  StepTask: { label: "Step Task", labelPlural: "Step Tasks" },
  Succession: { label: "RFLPSuccession", labelPlural: "RFLPSuccessions" },
  SysMLBehavior: { label: "SysML Behavior", labelPlural: "SysML Behaviors" },
  SysMLClassifier: { label: "SysML Classifier", labelPlural: "SysML Classifiers" },
  SysMLConstraint: { label: "Sys ML Constraint", labelPlural: "Sys ML Constraints" },
  SysMLElement: { label: "SysML Element", labelPlural: "SysML Elements" },
  SysMLExpression: { label: "Sys ML Expression", labelPlural: "Sys ML Expressions" },
  SysMLFeature: { label: "SysML Feature", labelPlural: "SysML Features" },
  SysMLNamespace: { label: "SysML Namespace", labelPlural: "SysML Namespaces" },
  SysMLStructure: { label: "SysML Structure", labelPlural: "SysML Structures" },
  SysMLType: { label: "SysML Type", labelPlural: "SysML Types" },
  SysMLUnit: { label: "SysML Unit", labelPlural: "SysML Units" },
  SysMLUsage: { label: "SysML Usage", labelPlural: "SysML Usages" },
  SystemPrompt: { label: "System Prompt", labelPlural: "System Prompts" },
  Task: { label: "Task", labelPlural: "Tasks" },
  TaskHistory: { label: "Task History", labelPlural: "Task Historys" },
  TaskNode: { label: "Task Node", labelPlural: "Task Nodes" },
  TaskResult: { label: "Task Result", labelPlural: "Task Results" },
  TaskRun: { label: "Task Run", labelPlural: "Task Runs" },
  TextPart: { label: "Text Part", labelPlural: "Text Parts" },
  ThinkingPart: { label: "Thinking Part", labelPlural: "Thinking Parts" },
  Thread: { label: "Thread", labelPlural: "Threads" },
  ThreadTask: { label: "Thread Task", labelPlural: "Thread Tasks" },
  ToolCallPart: { label: "Tool Call Part", labelPlural: "Tool Call Parts" },
  ToolCallResponse: { label: "Tool Call Response", labelPlural: "Tool Call Responses" },
  Unit: { label: "RFLPUnit", labelPlural: "RFLPUnits" },
  UpdatesSummaryTask: { label: "Updates Summary Task", labelPlural: "Updates Summary Tasks" },
  User: { label: "User", labelPlural: "Users" },
  ValidationTask: { label: "Validation Task", labelPlural: "Validation Tasks" },
  VersioningBranch: { label: "Versioning Branch", labelPlural: "Versioning Branchs" },
  VersioningCommit: { label: "Versioning Commit", labelPlural: "Versioning Commits" },
  VersioningOp: { label: "Versioning Op", labelPlural: "Versioning Ops" },
  VersioningOrigin: { label: "Versioning Origin", labelPlural: "Versioning Origins" },
  VersioningOverlay: { label: "Versioning Overlay", labelPlural: "Versioning Overlays" },
  VersioningPin: { label: "Versioning Pin", labelPlural: "Versioning Pins" },
  VersioningRelease: { label: "Versioning Release", labelPlural: "Versioning Releases" },
  VersioningRow: { label: "Versioning Row", labelPlural: "Versioning Rows" },
  Workspace: { label: "Workspace", labelPlural: "Workspaces" },
} as const;

export type ModelName = keyof typeof modelDisplayConfig;
